import * as actions from './actions'
import * as getters from './getters'

import { SET_MYSHIPMENTS, SET_NEWSHIPMENTS, SET_OFFERS, RESET_SHIPMENTS } from './mutation-types'
;('use strict')

// const initialState = { allOffers: [], newshipments: [], myshipments: [] }

function initialState() {
  return {
    allOffers: [],
    newshipments: [],
    myshipments: []
  }
}

const mutations = {
  [SET_NEWSHIPMENTS](state, shipments) {
    state.newshipments = shipments
  },

  [SET_MYSHIPMENTS](state, shipments) {
    state.myshipments = shipments
  },

  [SET_OFFERS](state, offers) {
    state.allOffers = offers
  },
  [RESET_SHIPMENTS]: state => {
    // acquire initial state
    const s = initialState()
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  }
}

export default {
  state: initialState,
  actions,
  getters,
  mutations
}
